var app = new Vue({
    el: '#wrap',
    data: {
        guid: '',
        buses: [],
        filteredBuses: [],
        locations: {
            departure: '',
            destination: '',
        },
        showSeatSelection: false,
        selectedBus: null,
        passengerCount: 0,
        showContinue:false,
    },
    created: function(){

    },
   
    methods: {
        setGUID: function(guid){
            this.guid = guid;
        },
        setBuses: function (buses) {
            this.reset();
            this.buses = buses.slice();
            this.filteredBuses = buses.slice();
        },
        setLocations: function (data) {
            this.locations = data;
        },
        setPassengerCount: function(count){
          this.passengerCount = count;
        },
        open: function () {
            $('.pop-sorting').fadeToggle("fast");
        },
        openBusDetail: function(bus){
            this.showSeatSelection = true;
            this.selectedBus = bus;
            this.filteredBuses.forEach(function (item) {
                if (bus.voyageTrackingNumber == item.voyageTrackingNumber){
                    item.hide = false;
                }
                else{
                    item.hide = true;
                }
            })
        },
        seatselectchanged :function(status) {
          this.showContinue=status;	
        },
        showAll: function () {
            this.showSeatSelection = false;
            this.filteredBuses.forEach(function (item) {
                    item.hide = false;
            });
        },
        openCloseFilter: function () {
            $('.resultLeft').fadeToggle("fast");
            //$(this).toggleClass("openFilter");
        },
        reset: function () {
            this.showSeatSelection = false;
            if (this.$refs.busFilters){
                this.$refs.busFilters.resetFilters();
            }
            if (this.$refs.seatSelection){
                this.$refs.seatSelection.reset();
            }

        },
        buyTicket: function () {
            this.$refs.seatSelection.buyTicket();
        }
    },
    computed: {
        selectedBusPrice: function() {
            var price = this.selectedBus.ticketPrice;
            return numberFormat(price, 2);
        }
    },
    watch: {
        filteredBuses: {
            handler: function(){
                this.showAll();
            },
            deep: true
        }
    }
});